import { serviceRequest } from './service-request';
import type { BaseViewModel } from 'node_modules/@cognitoforms/types/server-types/base-view-model';
import type { SubscriptionSettingsCreateViewModel as BaseSubscriptionSettingsCreateViewModel } from '@cognitoforms/types/server-types/services/view-models/subscription-settings-create-view-model';
import type { SubscriptionSettingsViewModel } from '@cognitoforms/types/server-types/services/view-models/subscription-settings-view-model';
import type { SubscriptionCostViewModel } from '@cognitoforms/types/server-types/services/controllers/svc-controllers/subscription-cost-view-model';
import type { DowngradeFeedbackSurvey } from '@cognitoforms/types/server-types/services/controllers/svc-controllers/downgrade-feedback-survey';
import type { WalletRefillSettingsViewModel } from '@cognitoforms/types/server-types/services/controllers/svc-controllers/wallet-refill-settings-view-model';

type SubscriptionSettingsCreateViewModel = Omit<BaseSubscriptionSettingsCreateViewModel, keyof BaseViewModel>;

export type {
	SubscriptionSettingsCreateViewModel,
	SubscriptionSettingsViewModel,
	SubscriptionCostViewModel,
	DowngradeFeedbackSurvey,
	WalletRefillSettingsViewModel
};

export function getSubscriptionSettings(model: SubscriptionSettingsCreateViewModel): Promise<SubscriptionSettingsViewModel> {
	return serviceRequest('svc/subscription-billing/create', model, { method: 'POST' });
}

export function updateSubscriptionSettings(model: SubscriptionSettingsViewModel) {
	return serviceRequest('svc/subscription-billing/update', model, { method: 'POST' });
}

export function generateSubscriptionCost(model: SubscriptionSettingsViewModel, options?: { signal?: AbortSignal }): Promise<SubscriptionCostViewModel> {
	return serviceRequest('svc/subscription-billing/cost', model, { method: 'POST', signal: options?.signal });
}

export function createWalletRefill(): Promise<WalletRefillSettingsViewModel> {
	return serviceRequest('svc/subscription-billing/wallet/create', {}, { method: 'POST' });
}

export function refillWallet(amount: number, submissionToken: string): Promise<void> {
	return serviceRequest('svc/subscription-billing/wallet/refill', { Amount: amount, SubmissionToken: submissionToken }, { method: 'POST' });
}

export function submitDowngradeSurvey(downgradeData: DowngradeFeedbackSurvey) : Promise<void> {
	return serviceRequest('svc/subscription-billing/downgrade-survey', downgradeData, {
		method: 'POST'
	});
}